<!-- 权责清单主体导航组件 -->
<template>
    <div class="v-nav">
        <c-tabs :xscjOption="xscjOption" @buildAccrualListReqLv2="buildAccrualListReqLv2"></c-tabs>
        <Row class="nav-panel" :gutter="16">
            <Col span="4" class="nav-btn-item" :class="{'nav-btn-active': active == DefaultDict.zqly}">
            <span @click="changeZqly(DefaultDict)">{{ DefaultDict.zqly }}</span>
            <!-- <Button long @click="changeZqly(DefaultDict)">{{ DefaultDict.zqly }}</Button> -->
            </Col>
            <Col span="4" v-for="item in ZqlyParams.zqlyOption" :key="item.id" class="nav-btn-item"
                :class="{'nav-btn-active': active == item.zqly}" :title="item.zqly">
            <span @click="changeZqly(item)">{{ item.zqly }}</span>
            <!-- <Button long @click="changeZqly(item)">{{ item.zqly }}</Button> -->
            </Col>
        </Row>
        <Row>
            <Col span="24" class="nav-btn-extend" ref="btn-extend">
            <div class="btn-open" v-if="ZqlyParams.zqlyOption.length > 5" @click="toggleNavPanel()">
                {{ this.IsOpen ? '收起' : '更多' }}</div>
            </Col>
        </Row>
    </div>
</template>

<script>
    import CTabs from '@/components/tabs/CTabs.vue'
    import { reqDicListData } from "@/api/index";

    export default {
        name: 'VNav',
        components: {
            CTabs
        },
        props: {
            xscjOption: {
                type: Array,
                default() {
                    return []
                }
            },
            // 小驼峰
            zqlyOption: {
                type: Array,
                default() {
                    return []
                }
            },
            pageSize: {
                type: Number,
                default() {
                    return 10
                }
            }
        },
        data() {
            return {
                // 行使层级选中值
                Xscj: '',
                ZqlyParams: {
                    zqly: '',// 职权领域选中值
                    zqlyLabel: '',// 职权领域选择文本值
                    zqlyOption: []// 职权领域字典表
                },
                DefaultDict: {
                    cjbm: '',
                    id: '',
                    lybm: '',
                    zqly: '全部部门'
                },
                // 是否展开全部部门
                IsOpen: false,
                // 展开面板默认高
                cPanelHeight: 140,
                active: '全部部门'
            }
        },
        computed: {
        },
        watch: {
            // 默认查询bm02，即省级数据
            'zqlyOption': {
                handler() {
                    this.ZqlyParams.zqlyOption = this.filterZqlyOption('02');
                    this.buildAccrualListReqLv2('02', 'xscj');
                },
            },
            // 字典长度变化，重新计算展开面板高度
            'ZqlyParams.zqlyOption': {
                handler() {
                    this.cPanelHeight = this.ZqlyParams.zqlyOption.length > 0 ? Math.ceil(this.ZqlyParams.zqlyOption.length / 6) * 70 : 140;
                    let tempStyle = this.IsOpen ? 'height: ' + this.cPanelHeight + 'px' : 'height 140px';
                    this.$refs['btn-extend'].$parent.$parent.$children[1].$el.style = tempStyle;
                },
            }
        },
        mounted() {

        },
        methods: {
            // 请求参数,拼接导航组件内请求参数
            buildAccrualListReqLv2(value, flag) {
                // 返回行使层级编码
                this.Xscj = value;
                this.active = '全部部门';
                this.ZqlyParams.zqly = '';
                this.ZqlyParams.zqlyLabel = '';
                this.ZqlyParams.zqlyOption = this.filterZqlyOption(value);
                this.callbackReq(flag);
            },

            // 过滤，按照行使层级编码过滤职权领域字典表
            filterZqlyOption(value) {
                let arr = [];
                this.zqlyOption.forEach(item => {
                    if (item.cjbm == value) {
                        arr.push(item);
                    }
                });
                return arr;
            },

            // 返回参数,返回导航组件内参数给父组件Accrual
            callbackReq(flag) {
                let params = {
                    xscj: this.Xscj,
                    zqly: this.ZqlyParams.zqly,
                    // zqlx: this.Zqlx,
                    pageSize: this.pageSize,
                    pageNum: 1
                };
                this.$emit("buildAccrualListReq", params, flag, this.ZqlyParams);
            },

            // 请求参数，选择职权领域时替换拼接的参数
            changeZqly(data) {
                this.active = data.zqly;
                this.ZqlyParams.zqly = data.lybm;
                this.ZqlyParams.zqlyLabel = data.zqly;
                this.callbackReq('zqly');
            },

            // 展开面板，查看全部职权部门
            toggleNavPanel() {
                this.IsOpen = !this.IsOpen;
                let tempStyle = this.IsOpen ? 'height: ' + this.cPanelHeight + 'px' : 'height 140px';
                this.$refs['btn-extend'].$parent.$parent.$children[1].$el.style = tempStyle;
            }
        }
    }
</script>

<style scoped>
    .ivu-col {
        /* padding: 0 3%; */
    }

    .nav-panel {
        overflow: hidden;
        padding: 0 20px;
        height: 140px;
        transition: height 0.6s ease;
    }

    .nav-btn-item {
        margin: 10px 0;
        font-size: 20px;
        color: #585f62;
    }

    .nav-btn-item span {
        float: left;
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        /* font-weight: bold; */
        color: #585f62;
        border: 1px solid #e0e8f7;
        border-radius: 3px;
        background-color: #f7f8fc;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .nav-btn-item:hover span {
        color: #fff;
        border: 1px solid #1867dd;
        border-radius: 3px;
        background-color: #1867dd;
        cursor: pointer;
        transition: all 0.3s;
    }

    .nav-btn-active span {
        color: #fff;
        border: 1px solid #1867dd;
        border-radius: 3px;
        background-color: #1867dd;
        cursor: pointer;
    }

    .nav-btn-extend {
        margin: 8px 0;
    }

    .btn-open {
        text-align: center;
        color: #1867dd;
        cursor: pointer;
    }
</style>